// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4051b0ef","488":"d1b80fcc","977":"466b2b2a"}[chunkId] + ".chunk.js";
};